import { Checkbox } from '@backstage/ui';

import styles from './FilterSection.module.css';

export interface CheckboxFilterProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  name?: string;
  className?: string;
}

/**
 * Labelled on/off filter, e.g. "Owned" or "Starred".
 *
 * @example
 * <CheckboxFilter
 *   label="Starred"
 *   checked={'starred' in selectedFilters}
 *   onChange={checked => (checked ? setFilter(...) : clearFilter(...))}
 * />
 */
export const CheckboxFilter = ({
  label,
  checked,
  onChange,
  name,
  className,
}: CheckboxFilterProps) => (
  <Checkbox
    name={name}
    isSelected={checked}
    onChange={onChange}
    className={[styles.checkbox, className].filter(Boolean).join(' ')}
  >
    {label}
  </Checkbox>
);
